export const APP_FILTER_TYPES = Object.freeze({
  QUERY: "query",
  CASCADE: "cascade",
  SINGLE: "single",
  MULTIPLE: "multiple",
});

export const FACET_PATH_DELIMITER = ">";

export const CASCADE_NAMES = {
  "relevant-fuer-reihe-band": ["reihe", "band"],
  "relevant-fuer-reihe-reihenausgabe-band": ["reihe", "reihenausgabe", "band"],
  "bildungsbereich-schulform": ["bildungsbereich", "schulform"],
};

export const LEHRERINNEN_TOGGLE = {
  FILTER_INPUT_NAME: "zielgruppe",
  VALUE: "TARGET_GROUP_NAME_#_LEHRERINNEN",
  NAME: "lehrkraefte",
};

export const DIGITAL_TOGGLE = {
  FILTER_INPUT_NAME: "digital",
  VALUE: "DISTRIBUTIONSFORM_#_DIGITAL",
  NAME: "digital",
};
